import axios from 'axios'
import store from '@/store'
import router from '@/router-v2'
import matchWhitelist from '@/router-v2/whitelist'
import { getStorage } from './storage'
import { aesAndBase64Encryption, aesAndBase64Decryption } from '@/tools/aes-encryption'

const fleetApiPattern = new RegExp('^/fleet(/.*)?', 'i')

const service = axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 50000
})

service.interceptors.request.use(
  config => {
    if (fleetApiPattern.test(config.url)) {
      if (typeof config.headers['portal-token'] !== 'string') {
        if (getStorage('x-portal-token') === 'yes') {
          delete config.headers['portal-token']
          config.headers['x-portal-token'] = getStorage()
        } else {
          config.headers['portal-token'] = getStorage() || getStorage('commandTemporaryToken') || sessionStorage.getItem('command_UUID')
        }
      }
      config.headers['client'] = 'Truckerpath_Command/5.8.0'
    } else if (!config.headers['disable-token']) {
      if (config.method === 'get') {
        config.data = { unused: 0 }
        config.headers['Content-Type'] === 'application/json;charset=UTF-8'
      }
      config.headers['x-auth-token'] = process.env.VUE_APP_TOKEN
      config.headers['client'] = process.env.VUE_APP_CLIENT
      config.headers['Installation-ID'] = process.env.VUE_APP_INSTALLATION_ID
      config.headers['Access-Control-Allow-Headers'] = '*'
      config.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS'
      config.headers['Access-Control-Allow-Origin'] = '*'
      if (typeof config.headers['portal-token'] !== 'string') {
        config.headers['portal-token'] = getStorage() || getStorage('commandTemporaryToken') || sessionStorage.getItem('command_UUID')
      }
    } else {
      delete config.headers['disable-token']
    }
    if (!config.headers.notEncrypted) {
      config.originalData = config.data
      config.data = config.data ? { data: aesAndBase64Encryption(config.data) } : config.data
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  async response => {
    try {
      let retry = response.config.retry || 0
      if (typeof response.data === 'string' && !response.config.headers.notEncrypted) {
        return Object.assign({}, response, { data: aesAndBase64Decryption(response.data) })
      } else if (response.data.code === 588 && retry < 5 && !response.config.noReacquire) {
        await store.dispatch('user/getEncryptionKey')
        return service(Object.assign({}, response.config, { retry: retry + 1, data: response.config.originalData }))
      }
      return response
    } catch (error) {
      console.log(error, 'encryption response')
      return response
    }
  },
  error => {
    const response = error.response
    if (response) {
      if (response.status === 401) {
        if (!matchWhitelist(router.currentRoute.path)) {
          return store.dispatch('user/logout')
        }
      }
    }
    return Promise.reject(error)
  }
)
export default service

// 兼容老接口数据
export function requestService(prarms, callbackPrarms) {
  callbackPrarms = callbackPrarms || {}
  return new Promise(function(resolve, reject) {
    service(prarms).then(
      function(res) {
        resolve({ callbackPrarms, res })
      },
      function(error) {
        reject({ callbackPrarms, error })
      }
    )
  })
}